import React from 'react';
import PropTypes from 'prop-types';

const Loader = ({ 
    children, 
    loading = 'primary',
    ...props 
}) => (
    <div
        className={`ld-wrapper`}
        style={{
            opacity: loading ? 1 : 0,
            width: 20,
            height: 20,
            borderWidth: Math.floor(20 / 10),
            left: `calc(50% - ${20 / 2}px)`,
            top: `calc(50% - ${20 / 2}px)`,
            padding: Math.floor(20 / 6),
        }}
        {...props}>
        <div
            className="ld"
            style={{
                borderWidth: Math.floor(20 / 10),
            }}
        ></div>
    </div>
);

Loader.propTypes = {
    loading: PropTypes.bool
};

export default Loader;